import { render, staticRenderFns } from "./businessLicenseStyle.vue?vue&type=template&id=168a102d&scoped=true"
import script from "./businessLicenseStyle.vue?vue&type=script&lang=js"
export * from "./businessLicenseStyle.vue?vue&type=script&lang=js"
import style0 from "./businessLicenseStyle.vue?vue&type=style&index=0&id=168a102d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a102d",
  null
  
)

export default component.exports